import { Outlet, useLocation } from "react-router-dom";

import MainNav from "./MainNav";
import Footer from "./Footer";
import CookieBanner from "../Cookies/CookieBanner";
import { useEffect, useState } from "react";
import { useAnalytics, useFirestore } from "reactfire";
import { logEvent } from "firebase/analytics";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";
import { doc, DocumentSnapshot, FirestoreError, onSnapshot } from "firebase/firestore";
import SiteBanner from "../Page/SiteBanner";
import Loading from "../General/Loading";
import { FirestoreSiteConfigConverter, SiteConfig } from "../../FirestoreConverters";

function Layout() {
  const analytics = useAnalytics()
  const { pathname } = useLocation()
  useDocumentTitle()

  useEffect(() => {
    logEvent(analytics, "page_view", {page_location: pathname})
  }, [pathname, analytics])

  const firestore = useFirestore()

  const [siteConfig, setSiteConfig] = useState<SiteConfig | false>()
  useEffect(() => {
    const streamConfig = (snapshotHandler: (snapshot: DocumentSnapshot<SiteConfig>) => void, errorHandler: (e: FirestoreError) => void) => {
      const configRef = doc(firestore, "config/site")
        .withConverter(FirestoreSiteConfigConverter);
      return onSnapshot(configRef, snapshotHandler, errorHandler)
    }

    const unsub = streamConfig(
      (snapshot) => {
        const config = snapshot.data()
        if (config === undefined || config.bannersEnabled === undefined) {
          return setSiteConfig(false)
        }
        setSiteConfig(config)
      },
      (e) => {
        console.log(e)
        setSiteConfig(false)
      }
    )
    return unsub
  }, [firestore, setSiteConfig])

  if (siteConfig === undefined) return <Loading />

  if (siteConfig !== false && siteConfig.bannersEnabled === true) {
    return <SiteBanner />
  }

  return (
    <div className="text-white text-center font-poppins break-words relative min-h-screen flex flex-col">
      <div>
        <MainNav />
      </div>

      <div className="flex-grow bg-white text-my-grey flex flex-col">
        <Outlet />
      </div>

      {/*
      <div className="testimonials hidden max-w-screen-lg mx-6 md:mx-auto">
        <div>
          What do people say?
        </div>
        <div className="grid grid-cols-6 justify-center">
          <div className="">
            &lt;
          </div>
          <div className="col-span-4">
            some awesome words about how great it was to actually receive cash and have it in my account within a x days!
          </div>
          <div className="">
            &gt;
          </div>
        </div>
      </div>
      */}

      <Footer />

      <CookieBanner />
    </div>
  );
}

export default Layout